var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Typography, Button, Card, Form, Input, Popconfirm, Select, Space, Table, Tag, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { createAdBanner, deleteAdBanner, fetchAdminAdBanners, updateAdBanner, updateAdBannerSortOrder } from '../cores/api/api-dashboard';
import { BANNER_QUERY_KEY, STATUS_COLOR_MAP, STATUS_LABEL_MAP } from '../contants/option';
import BannerFormModal from './banner-form';
dayjs.extend(utc);
dayjs.extend(timezone);
const JAPAN_TIMEZONE = 'Asia/Tokyo';
const Link = Typography.Link;
const formatDatetime = (value, fallback) => {
    if (!value)
        return fallback;
    return dayjs(value).tz(JAPAN_TIMEZONE).format('YYYY-MM-DD HH:mm');
};
const resolveBannerStatus = banner => {
    if (!banner.active)
        return 'inactive';
    return 'active';
};
export default function BannerPage({ embedded = false }) {
    var _a, _b;
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), filterForm = _Form$useForm2[0];
    const _message$useMessage = message.useMessage(), _message$useMessage2 = _slicedToArray(_message$useMessage, 2), messageApi = _message$useMessage2[0], contextHolder = _message$useMessage2[1];
    const _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isModalOpen = _useState2[0], setIsModalOpen = _useState2[1];
    const _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), editingBanner = _useState4[0], setEditingBanner = _useState4[1];
    const _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), title = _useState6[0], setTitle = _useState6[1];
    const _useState7 = useState(), _useState8 = _slicedToArray(_useState7, 2), statusFilter = _useState8[0], setStatusFilter = _useState8[1];
    const _useState9 = useState(), _useState0 = _slicedToArray(_useState9, 2), mediaTypeFilter = _useState0[0], setMediaTypeFilter = _useState0[1];
    const _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), draggingBannerId = _useState10[0], setDraggingBannerId = _useState10[1];
    const queryClient = useQueryClient();
    const apiFilters = useMemo(() => _objectSpread(_objectSpread(_objectSpread({
        per_page: 100,
        position: 2
    }, title.trim() ? {
        title: title.trim()
    } : {}), statusFilter ? {
        active: statusFilter === 'active'
    } : {}), mediaTypeFilter ? {
        media_type: mediaTypeFilter
    } : {}), [title, mediaTypeFilter, statusFilter]);
    const _useQuery = useQuery({
        queryKey: [...BANNER_QUERY_KEY, apiFilters],
        queryFn: () => fetchAdminAdBanners(apiFilters)
    }), data = _useQuery.data, isLoading = _useQuery.isLoading;
    const _useQuery2 = useQuery({
        queryKey: [...BANNER_QUERY_KEY, 'all-my-page'],
        queryFn: () => fetchAdminAdBanners({
            per_page: 100,
            position: 2
        })
    }), allMyPageBannersData = _useQuery2.data;
    const createMutation = useMutation({
        mutationFn: params => createAdBanner(params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || 'Create failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: BANNER_QUERY_KEY
            });
            messageApi.success('Banner created.');
            closeModal();
        })
    });
    const updateMutation = useMutation({
        mutationFn: ({ id, params }) => updateAdBanner(id, params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || 'Update failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: BANNER_QUERY_KEY
            });
            messageApi.success('Banner updated.');
            closeModal();
        })
    });
    const deleteMutation = useMutation({
        mutationFn: id => deleteAdBanner(id),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || 'Delete failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: BANNER_QUERY_KEY
            });
            messageApi.success('Banner deleted.');
        })
    });
    const reorderMutation = useMutation({
        mutationFn: updateAdBannerSortOrder,
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || 'Reorder failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: BANNER_QUERY_KEY
            });
            messageApi.success('Banner order updated.');
        })
    });
    const banners = (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [];
    const allMyPageBanners = (_b = allMyPageBannersData === null || allMyPageBannersData === void 0 ? void 0 : allMyPageBannersData.data) !== null && _b !== void 0 ? _b : [];
    const getCreateSortOrder = () => {
        if (!allMyPageBanners.length)
            return 1;
        const sortOrders = allMyPageBanners.map(banner => Number(banner.sort_order) || 0);
        return Math.max(...sortOrders) + 1;
    };
    const openCreateModal = () => {
        setEditingBanner(null);
        setIsModalOpen(true);
    };
    const openEditModal = banner => {
        setEditingBanner(banner);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setEditingBanner(null);
    };
    const handleSubmit = (payload, options) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (editingBanner) {
                yield updateMutation.mutateAsync({
                    id: editingBanner.id,
                    params: payload
                });
            }
            else {
                yield createMutation.mutateAsync(payload);
            }
            closeModal();
        }
        catch (error) {
            messageApi.error(error.message || 'Save failed.');
        }
    });
    const handleDelete = (id) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield deleteMutation.mutateAsync(id);
        }
        catch (error) {
            messageApi.error(error.message || 'Delete failed.');
        }
    });
    const handleDropBanner = (targetBanner) => __awaiter(this, void 0, void 0, function* () {
        const draggedBanner = banners.find(banner => banner.id === draggingBannerId);
        setDraggingBannerId(null);
        if (!draggedBanner || draggedBanner.id === targetBanner.id)
            return;
        if (draggedBanner.position !== targetBanner.position) {
            messageApi.error('Only banners in the same section can be reordered.');
            return;
        }
        const fromIndex = banners.findIndex(banner => banner.id === draggedBanner.id);
        const toIndex = banners.findIndex(banner => banner.id === targetBanner.id);
        if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex)
            return;
        try {
            yield reorderMutation.mutateAsync({
                id: draggedBanner.id,
                over_id: targetBanner.id,
                place: fromIndex < toIndex ? 'after' : 'before'
            });
        }
        catch (error) {
            messageApi.error(error.message || 'Reorder failed.');
        }
    });
    const handleFilter = values => {
        setTitle(values.keyword || '');
        setStatusFilter(values.status);
        setMediaTypeFilter(values.mediaType);
    };
    const handleResetFilter = () => {
        filterForm.resetFields();
        setTitle('');
        setStatusFilter(undefined);
        setMediaTypeFilter(undefined);
    };
    const columns = [{
            title: 'サムネイル画像',
            dataIndex: 'title',
            width: 300,
            render: (_, record) => /*#__PURE__*/ React.createElement("div", {
                className: "flex items-center gap-4"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "flex h-[72px] w-[144px] items-center justify-center overflow-hidden rounded-lg border border-[#e5e7eb] bg-[#f8fafc]"
            }, record.image_url ? /*#__PURE__*/ React.createElement("img", {
                src: record.image_url,
                alt: record.title || 'banner',
                className: "h-full w-full object-cover"
            }) : record.video_url ? /*#__PURE__*/ React.createElement("video", {
                src: record.video_url,
                className: "h-full w-full object-cover",
                muted: true
            }) : /*#__PURE__*/ React.createElement("span", {
                className: "text-[12px] text-[#6b7280]"
            }, "No media")))
        }, {
            title: 'タイトル',
            render: (_, record) => /*#__PURE__*/ React.createElement("div", {
                className: "truncate text-[12px] text-[#374151]"
            }, (() => {
                const bannerLink = record.media_type === 'video' ? record.video_link_url : record.image_link_url;
                const bannerTitle = record.title || '-';
                if (!bannerLink)
                    return bannerTitle;
                return /*#__PURE__*/ React.createElement(Link, {
                    href: bannerLink,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, bannerTitle);
            })())
        },
        // {
        //   title: 'Type',
        //   dataIndex: 'media_type',
        //   width: 100,
        //   render: (value: TypeAdBanner['media_type']) => (value === 'video' ? 'Video' : 'Image'),
        // },
        {
            title: 'ステータス',
            width: 100,
            render: (_, record) => {
                const status = resolveBannerStatus(record);
                return /*#__PURE__*/ React.createElement(Tag, {
                    color: STATUS_COLOR_MAP[status]
                }, STATUS_LABEL_MAP[status]);
            }
        }, {
            title: '開始日',
            dataIndex: 'start_date',
            width: 170,
            render: value => formatDatetime(value, '-')
        }, {
            title: '終了日',
            dataIndex: 'end_date',
            width: 170,
            render: value => formatDatetime(value, '-')
        }, {
            title: '',
            key: 'action',
            width: 180,
            render: (_, record) => /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
                onClick: () => openEditModal(record)
            }, "\u7DE8\u96C6"), /*#__PURE__*/ React.createElement(Popconfirm, {
                title: "\u672C\u5F53\u306B\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
                onConfirm: () => handleDelete(record.id)
            }, /*#__PURE__*/ React.createElement(Button, {
                danger: true,
                loading: deleteMutation.isPending
            }, "\u524A\u9664")))
        }];
    return /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'min-h-screen bg-[#f5f5f5] px-6 py-6'
    }, contextHolder, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-4 flex items-end justify-end gap-4"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: openCreateModal
    }, "\u30D0\u30CA\u30FC\u8FFD\u52A0")), /*#__PURE__*/ React.createElement(Form, {
        form: filterForm,
        layout: "vertical",
        onFinish: handleFilter
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ React.createElement(Space, {
        wrap: true,
        size: "large",
        align: "end"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30AD\u30FC\u30EF\u30FC\u30C9",
        name: "keyword"
    }, /*#__PURE__*/ React.createElement(Input, {
        allowClear: true,
        placeholder: "\u30BF\u30A4\u30C8\u30EB",
        style: {
            width: 260
        }
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "status"
    }, /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        style: {
            width: 180
        },
        options: [{
                label: '掲載中',
                value: 'active'
            }, {
                label: '停止中',
                value: 'inactive'
            }]
    })), /*#__PURE__*/ React.createElement(Form.Item, null, /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleResetFilter
    }, "\u30EA\u30BB\u30C3\u30C8"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit"
    }, "\u30D5\u30A3\u30EB\u30BF\u30FC"))))))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: isLoading,
        columns: columns,
        dataSource: banners,
        pagination: {
            pageSize: 10
        },
        scroll: {
            x: 1280
        },
        onRow: record => ({
            draggable: true,
            onDragStart: () => {
                setDraggingBannerId(record.id);
            },
            onDragOver: event => {
                event.preventDefault();
            },
            onDrop: () => {
                void handleDropBanner(record);
            },
            onDragEnd: () => {
                setDraggingBannerId(null);
            },
            className: draggingBannerId === record.id ? 'cursor-grabbing opacity-60' : 'cursor-grab'
        })
    }))), /*#__PURE__*/ React.createElement(BannerFormModal, {
        open: isModalOpen,
        editingBanner: editingBanner,
        loading: createMutation.isPending || updateMutation.isPending,
        getCreateSortOrder: getCreateSortOrder,
        onCancel: closeModal,
        onSubmit: handleSubmit
    }));
}
